import React, { Component, Fragment } from "react";
import * as R from "ramda";
import axios from "axios";
import { formatAnswer } from "../../utils/formatAnswer";

class TestResult extends Component {
  state = {
    errorContent: "",
  };

  constructor(props) {
    super(props);
    this.count = 0;
    this.score = 0;
    this.level = "";
    this.results = [];
    this.errorContent = "";

    try {
      const qustionIdSort = R.sortWith([R.ascend(R.prop("questionId"))]);

      let KEYS = qustionIdSort(this.props.answerKey);
      let answers = qustionIdSort(this.props.storedAnswers);
      KEYS.forEach((KEY) => this.saveResults(KEY, answers));
      this.calculateScore();

      const formatedAnswers = [];
      KEYS.forEach((KEY) => {
        const questionId = KEY.questionId;
        const answer = R.find(R.propEq("questionId", questionId))(answers);
        const formatedAnswer = formatAnswer(this.props.testPages, KEY, answers);
        if (answer === undefined) {
          formatedAnswers.push({
            questionId,
            answer: formatedAnswer,
          });
          return;
        }

        formatedAnswers.push({
          ...answer,
          answer: formatedAnswer,
        });
      });

      const url =
        process.env.REACT_APP_UPDATE_EXAMDETAIL +
        "/" +
        this.props.candidate.examDetailId;
      const params = {
        correct_count: this.count,
        score: this.score,
        stored_answers: JSON.stringify(formatedAnswers),
      };

      axios
        .post(`${url}`, params)
        .then((res) => {
          const data = res.data;
          if (!data.success) {
            console.log(data);
          }
        })
        .catch((e) => {
          this.setState({
            errorContent: `${e.toString()}：${JSON.stringify(
              this.props.storedAnswers
            )}`,
          });
        });
    } catch (e) {
      this.setState({
        errorContent: `${e.toString()}：${JSON.stringify(
          this.props.storedAnswers
        )}`,
      });
    }
  }

  state = {
    isSaved: false,
  };

  saveResults(KEY, answers) {
    let questionId = KEY.questionId;
    if (KEY.type === "checkboxes") {
      questionId += KEY.startQuestionId - KEY.questionId;
    }
    const answer = R.find(R.propEq("questionId", questionId))(answers);
    const id = questionId.toString().padStart(2, "0");

    if (answer === undefined) {
      this.results.push({
        questionId: id,
        status: "empty",
        formattedAnswer: "( Not answered. )",
      });
      return;
    }

    const formattedAnswer = formatAnswer(this.props.testPages, KEY, answers);
    // console.log(formattedAnswer);

    let userAnswer = answer.answer;
    let actualAnswers =
      R.type(KEY.answer) === "Array" ? KEY.answer : [KEY.answer];
    if (
      this.props.testType === "L" &&
      KEY.type !== "radios" &&
      userAnswer.toLowerCase
    ) {
      userAnswer = userAnswer.toLowerCase();
      actualAnswers = actualAnswers.map((a) => a.toLowerCase());
    }

    const correct = {
      questionId: id,
      status: "correct",
      formattedAnswer: formattedAnswer,
    };
    const wrong = {
      questionId: id,
      status: "wrong",
      formattedAnswer: formattedAnswer,
    };

    if (KEY.type === "radios") {
      if (R.equals(answer.answer, KEY.answer)) {
        this.count++;
        this.results.push(correct);
      } else {
        this.results.push(wrong);
      }
    } else if (KEY.type === "checkboxes") {
      const answerIndexes = [];
      if (answer.answer) {
        answer.answer.forEach((checked, index) => {
          if (!checked) {
            return;
          }

          answerIndexes.push(index + 1);
        });
      }
      const currentAnswer =
        answerIndexes[KEY.questionId - KEY.startQuestionId] ?? -1;

      if (KEY.answer.includes(currentAnswer)) {
        this.count++;
        this.results.push(correct);
      } else {
        this.results.push(wrong);
      }
    } else {
      if (R.find(R.equals(userAnswer))(actualAnswers)) {
        this.count++;
        this.results.push(correct);
      } else {
        this.results.push(wrong);
      }
    }

    return;
  }

  calculateScore() {
    let count = this.count;
    let score = 0;
    let level = "Did not attempt the test";
    if (count >= 39) {
      score = 9;
      level = "Expert user";
    } else if (count >= 38) {
      score = 8.5;
      level = "Very good user";
    } else if (count >= 35) {
      score = 8;
      level = "Very good user";
    } else if (count >= 32) {
      score = 7.5;
      level = "Good user";
    } else if (count >= 30) {
      score = 7;
      level = "Good user";
    } else if (count >= 27) {
      score = 6.5;
      level = "Competent user";
    } else if (count >= 23) {
      score = 6;
      level = "Competent user";
    } else if (count >= 19) {
      score = 5.5;
      level = "Modest user";
    } else if (count >= 15) {
      score = 5;
      level = "Modest user";
    } else if (count >= 13) {
      score = 4.5;
      level = "Limited user";
    } else if (count >= 10) {
      score = 4;
      level = "Limited user";
    } else if (count >= 6) {
      score = 3.5;
      level = "Extremely limited user";
    } else if (count >= 4) {
      score = 3;
      level = "Extremely limited user";
    } else if (count > 0 && count < 4) {
      score = 2;
      level = "Intermittent user";
    }

    this.score = score;
    this.level = level;
  }

  renderResultContent(status, id, answer) {
    return (
      <li className={status}>
        {id}. <span>{answer}</span>
      </li>
    );
  }

  render() {
    // 交卷後只顯示「已儲存」的提示，不再當場公布分數與逐題對錯。
    //
    // 分數改由成績信寄出（伺服器端批改後自動寄給考生本人，並副本存檔），
    // 這樣比較貼近正式雅思考試的做法，也避免考生當場對答案、把題目背走。
    //
    // 注意：上面 constructor 裡的批改與送出邏輯完全保留未動——
    // 作答內容仍然照原本的方式存回伺服器，只有這裡的畫面換掉。
    const email = (this.props.candidate && this.props.candidate.email) || "";

    // 自我練習（從學習系統 hub 開的練習卷）：學生要的就是馬上檢討，
    // 所以不寄信、不等三科考完，直接請他回學習系統看逐題詳解。
    // 正式模考維持原樣（不當場公布分數，成績信寄出）。
    const isPractice =
      this.props.candidate && this.props.candidate.mode === "practice";

    if (isPractice) {
      const hub = (process.env.REACT_APP_STAGING_URL || "").replace(/\/+$/, "");
      return (
        <div className="test-result-container">
          {this.state.errorContent && (
            <Fragment>
              <p style={{ color: "red !important" }}>
                Error! Sorry but something goes wrong.
              </p>
              <p style={{ color: "red !important" }}>
                Copy the following text to website owner.
              </p>
              <p>{this.state.errorContent}</p>
            </Fragment>
          )}
          <h1>Practice completed</h1>
          <div>
            <p>All your responses have been stored.</p>
            <p>您的作答已儲存。</p>
            <br />
            <p>
              Go back to the learning system to see your score and a
              question-by-question review.
            </p>
            <p>回到學習系統即可看到分數與逐題詳解。</p>
            {hub && (
              <button
                className="back-to-dashboard"
                onClick={() => {
                  window.location.href = hub + "/mock-practice/history";
                }}
              >
                回學習系統看成績與詳解
              </button>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="test-result-container">
        {this.state.errorContent && (
          <Fragment>
            <p style={{ color: "red !important" }}>
              Error! Sorry but something goes wrong.
            </p>
            <p style={{ color: "red !important" }}>
              Copy the following text to website owner.
            </p>
            <p>{this.state.errorContent}</p>
          </Fragment>
        )}
        <h1>Test ended</h1>
        <div>
          <p>All your responses have been stored.</p>
          <p>您的回答已儲存。</p>
          <br />
<p>
            Your Listening and Reading results will be sent
            {email && (
              <>
                {" "}to <b>{email}</b>
              </>
            )}{" "}
            after you have completed all sections.
          </p>
          <p>
            三科全部完成後，聽力與閱讀的成績會一起寄到您的信箱
            {email && <> <b>{email}</b></>}。
          </p>
          {/*
            從總連結（dashboard）進來的話，還有下一科要考。
            不用 window.location.reload()——整頁重載會把密碼一起丟掉，
            學生得再輸一次。這裡只把作答狀態清掉，回到科目卡片頁。
            舊信裡的單科連結沒有下一科，不顯示這顆。
          */}
          {this.props.fromDashboard && (
            <button
              className="back-to-dashboard"
              onClick={this.props.returnToDashboard}
            >
              回到測驗首頁，進行下一科
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default TestResult;
